import axios from '../utils/axios';

/**
 * Download job logs for a specific day
 * @param {string} adminId - Admin ID
 * @param {string} jobName - Job name
 * @param {Object} params - Query parameters (year, month, day)
 * @returns {Promise} API response (blob)
 */
export default function downloadCronJobLog(adminId, jobName, params = {}) {
    return axios.get(`/admin/${adminId}/cron/jobs/${jobName}/logs/download`, {
        params,
        responseType: 'blob'
    });
}
